(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const filter = document.getElementById('gallery-filter');
  const sets = document.querySelectorAll('.image-set');

  filter.addEventListener('change', function () {
    const val = this.value;
    sets.forEach(set => {
      if (val === 'all' || set.dataset.category === val) {
        set.classList.remove('hidden');
      } else {
        set.classList.add('hidden');
      }
    });
  });

  const lightbox = document.getElementById('lightbox');
  const lightboxContent = document.getElementById('lightbox-content');
  let currentIndex = 0;

  function openLightbox(index) {
    currentIndex = index;
    const item = sets[index];
    const media = item.querySelector('img, iframe, video')?.cloneNode(true);
    lightboxContent.innerHTML = '';
    if (media) {
      media.removeAttribute('loading');
      lightboxContent.appendChild(media);
      lightbox.classList.add('show');
    }
  }

  sets.forEach((set, index) => {
    const img = set.querySelector('img');
    if (img) {
      img.addEventListener('click', () => openLightbox(index));
    }
  });

  window.changeLightbox = function (step) {
    currentIndex += step;
    if (currentIndex < 0) currentIndex = sets.length - 1;
    if (currentIndex >= sets.length) currentIndex = 0;
    openLightbox(currentIndex);
  }

  window.closeLightbox = function () {
    lightbox.classList.remove('show');
  }
});

  } catch(e) { console.error(e); }
})();
})();
